export { default } from "@src/features/traffic-flow/screens/TrafficFlowScreen.native";
